import * as Braze from '@braze/web-sdk'

// 初始化
export const initializeBraze = () => {
  const apiKey = process.env.VUE_APP_BRAZE_KEY

  Braze.initialize(apiKey, {
    baseUrl: 'sdk.iad-07.braze.com',
  })
  Braze.automaticallyShowInAppMessages()
  return Braze
}

// 设置 userID
export function brazeChangeUser(userIdentifier) {
  Braze.changeUser(userIdentifier)
}
